module.exports = __webpack_public_path__ + "ic_warning_24px.e21c6b9d92bc28313aaa.svg";